import React, { useState, useEffect, useContext, useRef, useCallback } from 'react'
import { FormContainer } from '../../uiwidgets/FormContainer';
import { FormField } from '../../uiwidgets/FormField';
import ProvinceSelect from 'uiwidgets/ProvinceSelect';
import PostalCode from 'uiwidgets/PostalCode';
import CountrySelect from 'uiwidgets/CountrySelect';
import { SubmitButton } from '../../uiwidgets/SubmitButton';
import { CancelButton } from '../../uiwidgets/CancelButton';
import { Row, Col, Table } from 'react-bootstrap';
import { evenRound } from '../../util/NumberUtils';
import { formatCurrency } from '../../util/Currency';
import { TenantContext } from '../../tenant/TenantContext';
import _ from "lodash";
import PayByElavon from './elavon/PayByElavon';
import OfflinePayment from './offline/OfflinePayment';
import { CheckoutContext } from './CheckoutContext';
import { SecurityContext } from 'security/SecurityContext';
import PayByStripe from './stripe/PayByStripe';
import { useNavigate } from 'react-router-dom';
import BillFragment from './BillFragment';
import DonationFragment from './DonationFragment';
import {
    isEmailAddressValid, isPostalCodeValid,
    isPhoneValid, doesStringHaveSpecialChars, containsAlphabetsOnly,
    containsAlphaNumAndSpaceAndPunctuationOnly, isNotXssChars
} from "util/Validators";
import { calculatePlatformFee } from 'util/PlatformFeeCalculator';
import PaymentSourceTypeSelect from 'uiwidgets/PaymentSourceTypeSelect';
import { validAddress } from 'util/Validators';
import { containsAlphaNumAndSpaceOnly } from 'util/Validators';
import { PaymentCartContext } from './PaymentCartContext';
import { API } from 'api/API';
import { PROFILE_URL, USER_EMAIL_ADDRESS_EXISTS } from 'config/config';
import { extractError } from '../../api/ErrorUtil';
import { Base64 } from "js-base64";
import AppSpinner from 'uiwidgets/AppSpinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { PAYMENT_CARDS } from 'config/config';
import StripeForm from './stripe/StripeForm';


const CheckoutForm = () => {

    const initialPayerData = {
        firstName: "",
        lastName: "",
        companyName: "",
        address: "",
        city: "",
        zip: "",
        mobilePhoneNumber: "",
        email: "",
        country: "CA",
        state: "ON"
    };
    const initialFormData = {
        payer: initialPayerData,
        paymentCartItems: [],
        paymentSourceType: "",
        paymentCorrespodence: "",
        customerConsentsToPayPfFees: false,
        receiptInCompanyName: false,
        paymentCards: [],
        paymentCardId: ""

    };

    const [formData, setFormData] = useState(initialFormData);
    const [formValidityData, setFormValidityData] = useState({});
    const { businessConfig } = useContext(TenantContext);
    const { paymentCartItems, calculateTotalAmount, addMultipleToCart } = useContext(PaymentCartContext);
    const [initSetup, setInitSetup] = useState(false);
    const paymentFunction = useRef(null);
    const { paymentData, paymentDispatch } = useContext(CheckoutContext);
    const secCtx = useContext(SecurityContext);
    const paymentGateway = businessConfig.paymentGateway;
    const navigate = useNavigate();

    const messageReset = () => {
        paymentDispatch({ type: 'RESET_MESSAGE_AND_ERRORS' });
        return {
            infoMessage: "",
            errors: {}
        }
    }

    const onToastClose = () => {
        setFormData({
            ...formData,
            ...messageReset()
        });
    }

    const getUserByEmailAddress = async (emailAddress) => {
        try {
            if (!secCtx.authState || !secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")) {
                return null;
            }
            let emailExistsUrl = USER_EMAIL_ADDRESS_EXISTS.replace('${userEmailAddress}', emailAddress);
            let response = await API.get(emailExistsUrl);
            let paymentCards = { data: [] };
            let errors = {};
            //also get credit cards
            try {
                paymentCards = await API.get(PAYMENT_CARDS + "/" + emailAddress);
            } catch (err) {
                if (errors.httpStatus !== 404) {
                    errors = extractError(err);
                }
            }
            setFormData({ ...formData, payer: response.data, paymentCards: paymentCards.data });
            return;
        } catch (err) {
            return null;
        }
    }

    const setupCheckoutForm = useCallback(async () => {
        let payer = initialPayerData,
            pmtCartItems = paymentCartItems;
        try {
            try {
                if (secCtx.authState && !secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")) {
                    let payerResp = await API.get(PROFILE_URL);
                    payer = payerResp.data;
                }
            } catch (err) {
                let errors = extractError(err);
                if (errors.httpStatus !== 404) {
                    setFormData({ ...formData, errors: errors });
                    return;
                }
            };

            const searchParams = new URLSearchParams(window.location.search);
            if (!_.isEmpty(searchParams.get("data"))) {
                const data = JSON.parse(Base64.decode(searchParams.get("data")));
                payer = data.payer;
                pmtCartItems = [data.paymentCartItem];
                addMultipleToCart(pmtCartItems);
            }
            //calculate total payment amount
            let totalPaymentAmount = calculateTotalAmount(businessConfig.salesTaxRate, pmtCartItems);
            let platformFee = calculatePlatformFee(totalPaymentAmount, businessConfig.businessFee.feeType, businessConfig.businessFee.fee);

            if (businessConfig.businessFee.feePayer === 'CUSTOMER_MANDATORY'
                || formData.customerConsentsToPayPfFees) {
                totalPaymentAmount = evenRound(parseFloat(totalPaymentAmount) + parseFloat(platformFee), 2);
            }

            //let paymentSourceType = "";
            //if (businessConfig.busPmtSrcTypes.length === 1) {
            //    paymentSourceType = businessConfig.busPmtSrcTypes[0].paymentSourceType;
            //}

            if (_.isEmpty(pmtCartItems)) {
                setFormData({ errors: { message: "Payment Cart isEmpty! Add payments items to the card by using donations or bill payment pages" } });
                return;
            }

            let formDataInitSetup = {
                ...formData,
                paymentCartItems: pmtCartItems,
                payer: payer,
                totalPaymentAmount: totalPaymentAmount,
                platformFee: platformFee,
                customerConsentsToPayPfFees: false,
                paymentSourceType: ""
            }
            setFormData(formDataInitSetup);
            setInitSetup(true);

        } catch (error) {

        }
    });

    useEffect(() => {
        setupCheckoutForm();
    }, []);

    useEffect(() => {
        if (!paymentData.paymentResult) {
            return;
        }
        const searchParams = new URLSearchParams(window.location.search);
        //different ways we can get payment result
        const urlPmtResult = searchParams.get("pmtresult");
        const directResult = paymentData.pmtResult;
        if (directResult) {
            navigate('/checkout-result', { state: { formData: formData } });
            return;
        }

        if (paymentData.paymentResult && paymentData.paymentResult !== 'PAYMENT_SUCCEEDED' && paymentData.paymentResult !== 'PAYMENT_WORKING') {
            setFormData({ ...formData, readOnly: false })
        } else {
            setFormData({ ...formData, pmtResult: urlPmtResult || directResult });
        }

    }, [paymentData.paymentResult])

    useEffect(() => {
        let errors = {};
        if (initSetup) {
            if (_.isEmpty(paymentCartItems)) {
                errors = { message: "Payment Cart isEmpty! Add payments items to the card by using donations or bill payment pages" };
            }

            setFormData({
                ...formData,
                paymentCartItems,
                totalPaymentAmount: calculateTotalAmount(businessConfig.salesTaxRate),
                errors: errors
            })

        }
    }, [paymentCartItems])

    const handlePayerChange = async (event) => {
        if (formData.readOnly) {
            return;
        }
        const name = event.target.name;
        const value = event.target.value;
        let receiptInCompanyName = formData.receiptInCompanyName;
        if (name === 'companyName' && _.isEmpty(value)) {
            receiptInCompanyName = false;
        }

        setFormData({
            ...formData,
            receiptInCompanyName: receiptInCompanyName,
            payer: {
                ...formData.payer,
                [name]: value
            }

        });
    }

    const handleCountryChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let defaultState = "ON";
        if (value === "US") {
            defaultState = "MI";
        }
        setFormData({
            ...formData,
            payer: {
                ...formData.payer,
                [name]: value,
                state: defaultState
            }

        });
    }

    const handleCustomerConsentChange = async (event) => {
        if (formData.readOnly) {
            return;
        }
        const name = event.target.name;
        const value = event.target.checked;

        let platformFee = 0.00;
        let totalPaymentAmount = 0.00;

        if (value) {
            platformFee = calculatePlatformFee(formData.totalPaymentAmount, businessConfig.businessFee.feeType, businessConfig.businessFee.fee);
            totalPaymentAmount = evenRound(parseFloat(formData.totalPaymentAmount) + parseFloat(platformFee), 2);
        } else {
            totalPaymentAmount = evenRound(parseFloat(formData.totalPaymentAmount) - parseFloat(formData.platformFee), 2);
            platformFee = calculatePlatformFee(totalPaymentAmount, businessConfig.businessFee.feeType, businessConfig.businessFee.fee);
        }
        setFormData({
            ...formData,
            [name]: value,
            totalPaymentAmount: totalPaymentAmount,
            platformFee: platformFee,
        })
    }

    const validateProfile = () => {


        let valResult = validateInput('companyName', formData.payer.companyName || "");
        if (valResult.hasError) {
            setFormValidityData({
                ...formValidityData,
                companyNameError: valResult.hasError,
                companyNameErrMsg: "Provide valid company name before selecting payment source type"
            });
            return false;
        }

        valResult = validateInput('email', formData.payer.email);
        if (valResult.hasError) {
            setFormValidityData({
                ...formValidityData,
                emailError: valResult.hasError,
                emailErrMsg: "Provide valid email before selecting payment source type"
            });
            return false;
        }
        valResult = validateInput('mobilePhoneNumber', formData.payer.mobilePhoneNumber);
        if (valResult.hasError) {
            setFormValidityData({
                ...formValidityData,
                mobilePhoneNumberError: valResult.hasError,
                mobilePhoneNumberErrMsg: "Provide valid mobile phone number before selecting payment source type"
            });
            return false;
        }
        valResult = validateInput('officePhoneNumber', formData.payer.officePhoneNumber || "");
        if (valResult.hasError) {
            setFormValidityData({
                ...formValidityData,
                officePhoneNumberError: valResult.hasError,
                officePhoneNumberErrMsg: "Provide valid office phone number before selecting payment source type"
            });
            return false;
        }
        valResult = validateInput('firstName', formData.payer.firstName);
        if (valResult.hasError) {
            setFormValidityData({
                ...formValidityData,
                firstNameError: valResult.hasError,
                firstNameErrMsg: "Provide valid first name before selecting payment source type"
            });
            return false;
        }
        valResult = validateInput('lastName', formData.payer.lastName);
        if (valResult.hasError) {
            setFormValidityData({
                ...formValidityData,
                lastNameError: valResult.hasError,
                lastNameErrMsg: "Provide valid last name before selecting payment source type"
            });
            return false;
        }
        valResult = validateInput('address', formData.payer.address);
        if (valResult.hasError) {
            setFormValidityData({
                ...formValidityData,
                addressError: valResult.hasError,
                addressErrMsg: "Provide valid address before selecting payment source type"
            });
            return false;
        }
        valResult = validateInput('city', formData.payer.city);
        if (valResult.hasError) {
            setFormValidityData({
                ...formValidityData,
                cityError: valResult.hasError,
                cityErrMsg: "Provide valid city before selecting payment source type"
            });
            return false;
        }
        valResult = validateInput('state', formData.payer.state);
        if (valResult.hasError) {
            setFormValidityData({
                ...formValidityData,
                stateError: valResult.hasError,
                stateErrMsg: "Provide valid state before selecting payment source type"
            });
            return false;
        }
        valResult = validateInput('country', formData.payer.country);
        if (valResult.hasError) {
            setFormValidityData({
                ...formValidityData,
                countryError: valResult.hasError,
                countryErrMsg: "Provide valid country before selecting payment source type"
            });
            return false;
        }
        valResult = validateInput('zip', formData.payer.zip);
        if (valResult.hasError) {
            setFormValidityData({
                ...formValidityData,
                zipError: valResult.hasError,
                zipErrMsg: "Provide valid postal code before selecting payment source type"
            });
            return false;
        }
        return true;
    }

    const handlePaymentSourceTypeChange = async (event) => {

        if (formData.readOnly) {
            return;
        }

        //ensure that the donor information is populeated.
        if (!validateProfile()) {
            return;
        }

        const name = event.target.name;
        const value = event.target.value;
        if (!secCtx.authState) {
            setFormData({
                ...formData,
                [name]: value,
                paymentCards: []
            });
            return;
        }
        try {
            if (value === 'CARD' && secCtx.profile.roles.includes("ROLE_CONSUMER")) {
                let paymentCards = await API.get(PAYMENT_CARDS);
                setFormData({
                    ...formData,
                    [name]: value,
                    paymentCards: paymentCards.data
                });

            } else {
                setFormData({
                    ...formData,
                    [name]: value
                });
            }
        } catch (err) {
            let errors = extractError(err);
            if (errors.httpStatus !== 404) {
                setFormData({ ...formData, errors: errors, [name]: value });
                return;
            } else {
                setFormData({
                    ...formData,
                    [name]: value
                });
            }
        };
    }

    const handleFormDataChange = async (event) => {
        if (formData.readOnly) {
            return;
        }

        const name = event.target.name;
        const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        setFormData({
            ...formData,
            [name]: value
        });
    }

    const handleCancel = async (event) => {
        event.preventDefault();
        navigate(-1);
    }

    const handleValidation = async (event) => {
        const name = event.target.name;
        const value = event.target.value;
        let { hasError, error } = validateInput(name, value);
        setFormValidityData({
            ...formValidityData,
            [name + 'Error']: hasError,
            [name + 'ErrMsg']: error
        })
    }

    const validateInput = (name, value) => {
        let hasError = false,
            error = ""
        switch (name) {
            case "firstName":
                if (value.trim() === "") {
                    hasError = true
                    error = "First name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid First Name. Only alpha characters are allowed";
                }
                else if (doesStringHaveSpecialChars(value)) {
                    hasError = true
                    error = "Invalid First Name. Avoid Special characters"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "lastName":
                if (value.trim() === "") {
                    hasError = true
                    error = "Last name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid Last Name. Only alpha characters are allowed";
                } else if (doesStringHaveSpecialChars(value)) {
                    hasError = true
                    error = "Invalid Last Name. Avoid Special characters"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "companyName":
                if (value.trim() === "") {
                    hasError = false
                    error = ""
                } else if (!containsAlphaNumAndSpaceAndPunctuationOnly(value)) {
                    hasError = true
                    error = "Invalid Company Name. Only alpha-numeric characters are allowed"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "address":
                if (value.trim() === "") {
                    hasError = true
                    error = "Address name cannot be empty"
                } else if (!validAddress(value)) {
                    hasError = true
                    error = "Invalid Address. Avoid Special characters"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "city":
                if (value.trim() === "") {
                    hasError = true
                    error = "City name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid City. Only alpha-numeric characters are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "state":
                if (value.trim() === "") {
                    hasError = true
                    error = "State name cannot be empty"
                } else if (!containsAlphaNumAndSpaceOnly(value)) {
                    hasError = true
                    error = "Invalid State. Only alpha-numeric characters are allowed"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "country":
                if (value.trim() === "") {
                    hasError = true
                    error = "Country name cannot be empty"
                } else if (!containsAlphabetsOnly(value)) {
                    hasError = true
                    error = "Invalid Country. Only alpha characters are allowed"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "email":
                if (value.trim() === "") {
                    hasError = true
                    error = "Email cannot be empty"
                } else if (!isEmailAddressValid(value)) {
                    hasError = true
                    error = "Invalid Email"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "mobilePhoneNumber":
                if (value.trim() === "") {
                    hasError = true
                    error = "Mobile cannot be empty"
                } else if (!isPhoneValid(value)) {
                    hasError = true
                    error = "Invalid Mobile Number. Use 10 digits only"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "officePhoneNumber":
                if (value.trim() === "") {
                    hasError = false;
                    error = "";
                } else if (!isPhoneValid(value)) {
                    hasError = true
                    error = "Invalid Office Number. Use 10 digits only"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "zip":
                if (value.trim() === "") {
                    hasError = true
                    error = "Postal Code cannot be empty"
                } else if (!isPostalCodeValid(value, formData.payer.country)) {
                    hasError = true
                    error = "Invalid Postal Code"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "paymentSourceType":
                if (value.trim() === "") {
                    hasError = true
                    error = "Payment Method must be selected"
                } else if (!containsAlphaNumAndSpaceAndPunctuationOnly(value)) {
                    hasError = true
                    error = "Invalid payment source type. Only alpha characters are allowed"
                } else {
                    hasError = false
                    error = ""
                }
                break
            case "paymentCorrespodence":
                if (value.trim() === "") {
                    hasError = false
                    error = ""
                } else if (value.length > 250) {
                    hasError = true
                    error = "The length of the message cannot be greater than 250 characters"
                } else if (!isNotXssChars(value)) {
                    hasError = true
                    error = "Invalid Payment Message. Only alpha characters are allowed";
                } else {
                    hasError = false
                    error = ""
                }
                break
            default:
                break
        }
        return { hasError, error }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        let isFormValid = true;
        const tagNames = ['select', 'input', 'textarea'];

        for (let tagName of tagNames) {
            //validate full form
            for (let i = 0; i < event.target.getElementsByTagName(tagName).length; i++) {
                let label = event.target.getElementsByTagName(tagName)[i].labels[0]?.innerHTML
                let fieldName = event.target.getElementsByTagName(tagName)[i].name;
                let fieldValue = event.target.getElementsByTagName(tagName)[i].value;
                let { hasError, error } = validateInput(fieldName, fieldValue);
                paymentDispatch({ type: 'PAYMENT_VALIDATION_ERROR', payload: { errors: { message: label + " is invalid" } } });
                setFormValidityData({
                    ...formValidityData,
                    [fieldName + 'Error']: hasError,
                    [fieldName + 'ErrMsg']: error
                })
                if (hasError) {
                    isFormValid = false;
                    return false;
                }
            }
        }

        paymentDispatch({ type: 'PAYMENT_WORKING' });
        setFormData({ ...formData, readOnly: true });
        console.log(formData);
        paymentFunction.current();

    }

    return (

        <FormContainer title="Payments Checkout" submitButtonFunction={handleSubmit}
            errors={{ ...formData.errors, ...paymentData.errors }} infoMessage={formData.infoMessage} toastCloseFunc={onToastClose}>
            {!_.isEmpty(formData.paymentCartItems) && <React.Fragment>
                {!formData.pmtResult && <>
                    {paymentData.paymentResult === 'PAYMENT_WORKING' &&
                        <Row><Col>
                            <AppSpinner />&nbsp;Please wait while payment methods are setup!
                        </Col></Row>}

                    <Row><Col>Please verify the information given below and click on the Pay button to make the payment.</Col></Row>

                    {formData.paymentCartItems && formData.paymentCartItems.map((paymentCartItem, idx) => (
                        <React.Fragment key={idx}>
                            <Row><Col>&nbsp;</Col></Row>
                            {(paymentCartItem.commitmentType === 'BILL') && <BillFragment paymentCartItem={paymentCartItem} idx={idx} key={'bill' + idx} allowDelete={true} />}
                            {(paymentCartItem.commitmentType === 'DONATION') && <DonationFragment paymentCartItem={paymentCartItem} idx={idx} key={'donation' + idx} allowDelete={true} />}

                        </React.Fragment>
                    ))}

                    <Row><Col>
                        <Table>
                            <tbody>
                                <tr>
                                    {businessConfig.businessFee.feePayer === 'CUSTOMER_OPTIONAL' && <td style={{ paddingLeft: 0 }}>
                                        <FormField
                                            type="checkbox"
                                            name="customerConsentsToPayPfFees"
                                            value={formData.customerConsentsToPayPfFees || false}
                                            checked={formData.customerConsentsToPayPfFees || false}
                                            onChange={handleCustomerConsentChange}
                                        />
                                    </td>}
                                    <td>
                                        {
                                            businessConfig.businessFee.feePayer === 'CUSTOMER_OPTIONAL' &&
                                            <>Payer agrees to pay for the transaction cost of: <b>{formatCurrency(parseFloat(formData.platformFee / 100), businessConfig.locale, businessConfig.currency)}</b></>
                                        }
                                        {
                                            businessConfig.businessFee.feePayer === 'CUSTOMER_MANDATORY' &&
                                            <>Payer is required to cover the transaction cost of: <b>{formatCurrency(parseFloat(formData.platformFee / 100), businessConfig.locale, businessConfig.currency)}</b>.
                                                By proceeding to pay, you agree to pay the platform fee.</>
                                        }
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </Col></Row>
                    <Row>
                        <Col>
                            <div><span>Total Payment</span> </div>
                        </Col>
                        <Col>
                            <div><span>
                                {formatCurrency(evenRound(parseFloat(formData.totalPaymentAmount) / 100, 2), businessConfig.locale, businessConfig.currency)}
                            </span> </div>
                        </Col>
                    </Row>
                    <Row><Col>&nbsp;</Col></Row>
                    <Row>
                        <Col>
                            <h6>User Profile</h6><br />
                        </Col>
                    </Row>
                    <Row>
                        <Col mb={6} lg={6} sm={12}>
                            <FormField name="firstName" label="First Name" type="text" value={formData.payer.firstName}
                                placeholder="First Name" onChange={handlePayerChange} onBlur={handleValidation}
                                valstate={!formValidityData.firstNameError} valMsg={formValidityData.firstNameErrMsg}
                                readOnly={formData.readOnly} />
                        </Col>
                        <Col mb={6} lg={6} sm={12}>
                            <FormField name="lastName" label="Last Name" type="text" value={formData.payer.lastName}
                                placeholder="Last Name" onChange={handlePayerChange} onBlur={handleValidation}
                                valstate={!formValidityData.lastNameError} valMsg={formValidityData.lastNameErrMsg}
                                readOnly={formData.readOnly} />
                        </Col>
                    </Row>
                    <Row>&nbsp;</Row>
                    <Row>
                        <Col mb={6} lg={6} sm={12}>
                            <FormField name="companyName" label="Company Name (optional)" type="text" value={formData.payer.companyName}
                                placeholder="Company Name" onChange={handlePayerChange} onBlur={handleValidation}
                                valstate={!formValidityData.companyNameError} valMsg={formValidityData.companyNameErrMsg}
                                readOnly={formData.readOnly || (secCtx.authState && !secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN"))} />
                        </Col>
                        <Col mb={6} lg={6} sm={12}>
                            <Table><tbody>
                                <tr>
                                    <td className="m-0 p-0" style={{ borderStyle: 'none' }} width="35px">
                                        <br /><FormField
                                            name="receiptInCompanyName"
                                            type="checkbox"
                                            checktype="checkbox"
                                            disabled={formData.readOnly || _.isEmpty(formData.payer?.companyName)}
                                            value={formData.receiptInCompanyName}
                                            checked={formData.receiptInCompanyName}
                                            onChange={handleFormDataChange}
                                            onBlur={handleValidation}
                                            valstate={!formValidityData.receiptInCompanyNameError}
                                            valMsg={formValidityData.receiptInCompanyNameErrMsg} />
                                    </td>
                                    <td className="m-0 p-0" style={{ borderStyle: 'none' }}>
                                        <br /><label><nobr>Receipt In Company Name <FontAwesomeIcon icon={faInfoCircle} title="may be disabled due to absence of Company Name in user profile" /></nobr></label>
                                    </td>
                                </tr>

                            </tbody></Table>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p className="card-category">
                                If you would like to have the receipt for the payments in the name of your organization instead of first and last name above, please
                                update the "Company Name" field
                                {secCtx.authState && !secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN") && <span> on the profile screen using the top right profile menu </span>}
                                {!secCtx.authState && <span> above </span>}
                                and select this checkbox.
                            </p>

                        </Col>
                    </Row>
                    <Row><Col>&nbsp;</Col></Row>
                    <Row>
                        <Col mb={6} lg={6} sm={12}>
                            <FormField name="email" label="Email" type="text" value={formData.payer.email}
                                placeholder="Email" onChange={handlePayerChange} onBlur={(event) => { handleValidation(event); getUserByEmailAddress(event.target.value) }}
                                valstate={!formValidityData.emailError} valMsg={formValidityData.emailErrMsg}
                                readOnly={formData.readOnly || (secCtx.authState && !secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN"))} />
                        </Col>
                        <Col mb={3} lg={3} sm={6}>
                            <FormField name="mobilePhoneNumber" label="Mobile Phone Number" type="text" value={formData.payer.mobilePhoneNumber}
                                placeholder="Mobile Phone Number" onChange={handlePayerChange} onBlur={handleValidation}
                                valstate={!formValidityData.mobilePhoneNumberError} valMsg={formValidityData.mobilePhoneNumberErrMsg}
                                readOnly={formData.readOnly || (secCtx.authState && !secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN"))} />
                        </Col>
                        <Col mb={3} lg={3} sm={6}>
                            <FormField name="officePhoneNumber" label="Office Phone Number" type="text" value={formData.payer.officePhoneNumber}
                                placeholder="Office Phone Number" onChange={handlePayerChange} onBlur={handleValidation}
                                valstate={!formValidityData.officePhoneNumberError} valMsg={formValidityData.officePhoneNumberErrMsg}
                                readOnly={formData.readOnly || (secCtx.authState && !secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN"))} />
                        </Col>
                    </Row>

                    <Row><Col>&nbsp;</Col></Row>
                    <Row>
                        <Col>
                            {formData.paymentSourceType !== 'OFFLINE' &&
                                <h6>Payment Card Address Verification</h6>}
                            {formData.paymentSourceType === 'OFFLINE' &&
                                <h6>Donor Profile Information</h6>}
                            <br />
                        </Col>
                    </Row>
                    {formData.paymentSourceType !== 'OFFLINE' &&
                        <Row><Col>
                            Please verify that the information given below corresponds to your payment card billing information. It will be used to verify the payment card
                        </Col></Row>}


                    <Row>
                        <Col mb={12} lg={12} sm={12}>
                            <FormField name="address" label="Address" type="text" value={formData.payer.address}
                                placeholder="Address" onChange={handlePayerChange} onBlur={handleValidation}
                                valstate={!formValidityData.addressError} valMsg={formValidityData.addressErrMsg}
                                readOnly={formData.readOnly} />
                        </Col>
                    </Row>
                    <Row>
                        <Col mb={2} lg={2} sm={6}>
                            <CountrySelect name="country" onChange={handleCountryChange} onBlur={handleValidation}
                                valstate={!formValidityData.countryError} valMsg={formValidityData.countryErrMsg}
                                readOnly={formData.readOnly} value={formData.payer.country} />
                        </Col>
                        <Col mb={4} lg={4} sm={6}>
                            <ProvinceSelect name="state" onChange={handlePayerChange} onBlur={handleValidation}
                                valstate={!formValidityData.stateError} valMsg={formValidityData.stateErrMsg}
                                readOnly={formData.readOnly} value={formData.payer.state} country={formData.payer.country} />
                        </Col>
                    </Row>

                    <Row>
                        <Col mb={5} lg={5} sm={12}>
                            <FormField name="city" label="City" type="text" value={formData.payer.city}
                                placeholder="City" onChange={handlePayerChange} onBlur={handleValidation}
                                valstate={!formValidityData.cityError} valMsg={formValidityData.cityErrMsg}
                                readOnly={formData.readOnly} />
                        </Col>

                        <Col mb={4} lg={4} sm={6}>
                            <PostalCode name="zip" label="Postal Code" type="text" value={formData.payer.zip}
                                placeholder="Postal Code" onChange={handlePayerChange} onBlur={handleValidation}
                                valstate={!formValidityData.zipError} valMsg={formValidityData.zipErrMsg}
                                readOnly={formData.readOnly} country={formData.payer.country} />
                        </Col>
                    </Row>

                    <Row>
                        <Col mb={6} lg={6} sm={12}>
                            {!secCtx.authState && <b>In order to do an offline donation, kindly ensure to sign in to your account first.</b>}
                            <PaymentSourceTypeSelect name="paymentSourceType" onChange={handlePaymentSourceTypeChange} onBlur={handleValidation}
                                valstate={!formValidityData.paymentSourceTypeError} valMsg={formValidityData.paymentSourceTypeErrMsg}
                                readOnly={formData.readOnly} value={formData.paymentSourceType} />
                        </Col>
                        <Col mb={6} lg={6} sm={12}>
                            {!_.isEmpty(formData.paymentCards) && (formData.paymentCards.length > 0) && (formData.paymentSourceType === 'CARD') &&
                                <>
                                    <FormField name="paymentCardId" label="Payment Cards" type="select"
                                        placeholder="Payment Cards" onChange={handleFormDataChange} onBlur={handleValidation}
                                        valstate={!formValidityData.paymentCardIdError} valMsg={formValidityData.paymentCardIdErrMsg}
                                        readOnly={formData.readOnly} value={formData.paymentCardId}>
                                        <option value="" key="noval">Select Payment Card</option>
                                        {formData.paymentCards.map((paymentCard, idx) => (
                                            <option value={paymentCard.paymentCardId} key={idx}>{paymentCard.maskedAccountNumber}</option>

                                        ))}
                                    </FormField><small><strong>if not selected, you will be able to enter payment card details manually when you click the pay button</strong></small></>}
                        </Col>
                    </Row>

                    <Row>
                        <Col mb={12} lg={12} sm={12}>
                            <FormField name="paymentCorrespodence" label="Payment Message" type="textarea" value={formData.paymentCorrespodence}
                                placeholder="Payment Message" onChange={handleFormDataChange} onBlur={handleValidation}
                                valstate={!formValidityData.paymentCorrespodenceError} valMsg={formValidityData.paymentCorrespodenceErrMsg}
                                readOnly={formData.readOnly} style={{ height: "100px" }} />
                        </Col>
                    </Row>
                    <Row><Col>&nbsp;</Col></Row>
                    <Row><Col>
                        &nbsp;
                        {!formData.pmtResult && formData.paymentSourceType === 'OFFLINE' && <OfflinePayment paymentFunction={paymentFunction} formData={formData} />}
                        {!formData.pmtResult && paymentGateway === 'ELAVON' && formData.paymentSourceType !== 'OFFLINE' &&
                            <PayByElavon paymentFunction={paymentFunction} formData={formData} />}
                        {!formData.pmtResult && paymentGateway === 'STRIPE' && formData.paymentSourceType !== 'OFFLINE' &&
                            <StripeForm paymentFunction={paymentFunction} formData={formData} />}
                    </Col></Row>
                </>}

                {!formData.pmtResult &&
                    <Row><Col>
                        <SubmitButton label='Pay' disabled={formData.readOnly} className="me-4" />
                        <CancelButton label='Cancel' disabled={formData.readOnly} onClick={handleCancel} />
                    </Col>
                    </Row>}
            </React.Fragment>}
        </FormContainer>
    )
}

export default CheckoutForm